var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 348.36586,
    height: 253.9449,
    viewBox: "0 0 348.36586 253.9449",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M592.79213,547.86022c-19.18663.47554-19.13688,28.58472,0,29.11223C611.97965,576.49691,611.9299,548.388,592.79213,547.86022Z",
    transform: "translate(-425.81707 -323.02755)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M684.3462,502.59315a139.78114,139.78114,0,0,0-20.0644-36.793c-14.63163-20.12437-34.24649-38.40458-58.79572-44.96878-21.07455-5.00277-45.104-1.76354-62.34323,11.9319-22.5689,19.148-31.43281,48.83681-43.41868,74.90725,18.26532-24.12611,32.49893-51.36307,54.13231-64.23026,13.41537-6.4627,21.92835-7.42909,38.375-6.15064,10.06507.81025,22.77946,5.07052,36.92956,14.27692,18.56828,12.41566,40.50284,33.90844,54.254,56.42115q2.89186,4.611,5.64512,9.3068C687.66273,512.34083,686.11063,507.42912,684.3462,502.59315Z",
    transform: "translate(-425.81707 -323.02755)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M770.36355,487.84091c-5.1698-25.58447-15.61957-49.99754-28.58183-72.56955-46.2448-78.17781-146.09418-127.1019-236.90019-61.97187-37.985,29.00228-59.39541,73.66766-79.06446,116.04888,12.60333-17.67763,23.78073-35.59513,36.26856-50.12392,17.51016-19.87362,31.34931-34.90926,50.01354-46.05556,59.45849-36.17417,132.53223-17.73,180.04749,25.4954,27.0786,25.57381,35.28773,35.59891,52.47894,61.28222,11.16585,16.99109,19.48071,33.30986,25.252,49.14776,1.49523,3.91222,2.94871,7.84288,4.30535,11.8033A269.29234,269.29234,0,0,0,770.36355,487.84091Z",
    transform: "translate(-425.81707 -323.02755)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M457.22959,452.65743c25.782-53.69179,88.72584-86.83006,147.58273-77.69841s108.80054,59.78441,117.10155,118.76419C697.22765,448.72867,650.126,416.781,599.192,410.4845S494.79447,423.70379,457.22959,452.65743Z",
    transform: "translate(-425.81707 -323.02755)",
    fill: "#ffc107"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.90848e6c181b3cf4a056fda3939bc2cf.svg";
export { ForwardRef as ReactComponent };